import { connect } from 'react-redux'
import * as action from '../../state/display/action'
import * as selector from '../../state/display/selector'

import InvoiceList from './InvoiceList'


const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
    }
}

const mapDispatchToProps = {
    createCorrection: action.createCorrection,
    showConfirmationModal: action.showConfirmationModal,
    closeConfirmationModal: action.closeConfirmationModal,
}


export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList)



// WEBPACK FOOTER //
// ./src/modules/invoice/component/list/InvoiceListContainer.js